var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66602C9.69467 2.66602 8.78533 2.93135 8 3.38735C7.21467 2.93135 6.30533 2.66602 5.33333 2.66602C2.39267 2.66602 0 5.05868 0 7.99935C0 10.94 2.39267 13.3327 5.33333 13.3327C6.30533 13.3327 7.21467 13.0673 8 12.6113C8.78533 13.0673 9.69467 13.3327 10.6667 13.3327C13.6073 13.3327 16 10.94 16 7.99935C16 5.05868 13.6073 2.66602 10.6667 2.66602ZM1.33333 7.99935C1.33333 5.79335 3.12733 3.99935 5.33333 3.99935C5.86533 3.99935 6.37267 4.10602 6.838 4.29535C5.90867 5.25602 5.33333 6.56068 5.33333 7.99935C5.33333 9.43802 5.90867 10.7427 6.838 11.7033C6.37267 11.8927 5.86533 11.9993 5.33333 11.9993C3.12733 11.9993 1.33333 10.2053 1.33333 7.99935ZM10.6667 11.9993C10.1347 11.9993 9.62733 11.8927 9.162 11.7033C10.0913 10.7427 10.6667 9.43802 10.6667 7.99935C10.6667 6.56068 10.0913 5.25602 9.162 4.29535C9.62733 4.10602 10.1347 3.99935 10.6667 3.99935C12.8727 3.99935 14.6667 5.79335 14.6667 7.99935C14.6667 10.2053 12.8727 11.9993 10.6667 11.9993Z",
    fill: "#5D5E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/union-icon.5c80ec27fa88412262c3ed6033ff57cc.svg";
export { ForwardRef as ReactComponent };